import { Typography } from "@stardust-ds/react"
import intl from "react-intl-universal"

import RcmpMoveIconLarge from "../../../assets/icons/MoveIconLarge"
import RcmpModalAdd from "../ModalAdd"
import styles from './index.module.scss'

export default function RcmpModalMoveInfo(props) {
  const {
    bIsOpen,
    bOnClose,
    fnHandleConfirm,
    cTextConfirmation,
    cCurrentName,
    cMoveName,
    cTitle,
  } = props
  return (
    <RcmpModalAdd
      title={cTitle}
      size="sm"
      isOpen={bIsOpen}
      fnHandleCancel={bOnClose}
      fnHandleConfirm={fnHandleConfirm}
      buttonSaveText={intl.get("modal_move.move")}
      buttonType="button"
    >
      <div className={styles.container}>
        <RcmpMoveIconLarge fill={"#6CB6E3"} />

        <div className={styles.textConfirmation}>
          <Typography type="p1" color="#415364">
            {cTextConfirmation}
          </Typography>
        </div>
        <div className={styles.moveData}>
          <div className={styles.row}>
            <Typography type="l1" color="#415364">
              {intl.get("modal_move.origin")}
            </Typography>
            <Typography type="p1" color="#415364">
              {cCurrentName}
            </Typography>
          </div>
          <div className={styles.row}>
            <Typography type="l1" color="#415364">
              {intl.get("modal_move.destination")}
            </Typography>
            <Typography type="p1" color="#415364">
              {cMoveName}
            </Typography>
          </div>
        </div>
      </div>
    </RcmpModalAdd>
  )
}